import { render, staticRenderFns } from "./blocker.vue?vue&type=template&id=1d50a4ca&scoped=true&"
import script from "./blocker.vue?vue&type=script&lang=js&"
export * from "./blocker.vue?vue&type=script&lang=js&"
import style0 from "./blocker.vue?vue&type=style&index=0&id=1d50a4ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d50a4ca",
  null
  
)

export default component.exports